{
  "hero": {
    "title": "Privacy Notice",
    "description": "What personal data NAPAICP collects, why, and who can access it. Retention periods, work ownership, and deletion requests are covered on the Data Policy page."
  },
  "quickNav": {
    "label": "On this page",
    "collect": "What we collect",
    "purpose": "Why we collect it",
    "access": "Who can access it",
    "thirdParty": "Third-party services",
    "children": "Minor users",
    "related": "Related pages"
  },
  "collect": {
    "heading": "What we collect",
    "description": "Depending on your role and activity on the platform, we may collect:",
    "items": {
      "identity": "Name, email address, school or organization; judges may also add an organization, title, expertise and bio (visible only to that competition's organizers)",
      "team": "Team name, team membership, advisor/mentor information",
      "submission": "Registration answers, submitted files and submission-form answers",
      "scoring": "Judges' scores and comments on a submission (visible only to that judge and authorized organizers), plus when a judge confirmed the judging terms and the optional reason given when declining a judge invitation (visible to the organizer)",
      "activity": "Account-related system activity, e.g. sign-in time, password changes, session events",
      "event": "When you use event services (shuttle, meals, help desk): your real name, organization, job title and optional mobile number for riding, companions' names, shuttle bookings and check-in records, lunch and banquet replies with dietary category and notes, help desk case content and an optional pre-departure reminder consent; email-only booking also holds a pending request until confirmed. Mobile numbers and dietary notes are stored encrypted, and this data is deleted 30 days after the event."
    }
  },
  "purpose": {
    "heading": "Why we collect it",
    "items": {
      "auth": "Account authentication and sign-in",
      "eligibility": "Confirming competition eligibility",
      "submission": "Managing and preserving competition submissions",
      "judging": "Supporting the judging process and score calculation",
      "notification": "Notifications about registration, scoring, and results",
      "audit": "Auditing and security, e.g. detecting anomalous access"
    }
  },
  "access": {
    "heading": "Who can access it",
    "description": "Access is scoped by role; holding a higher-level role does not mean automatic access to everyone else's data:",
    "roles": {
      "participant": {
        "title": "Participant",
        "description": "Can access their own and their team's data; cannot see other teams' submissions or scores."
      },
      "judge": {
        "title": "Judge",
        "description": "Can only access assigned submissions and related scoring data. Judge-facing APIs never return participant identity fields that should stay hidden."
      },
      "organizer": {
        "title": "Competition organizer",
        "description": "Can manage the competitions they run (registration, submissions, judging, and results) for those competitions only, not other competitions."
      },
      "platformAdmin": {
        "title": "Platform administrator",
        "description": "Can query necessary information across competitions for governance purposes. Platform-wide lists return only the minimal fields needed for governance; anything more sensitive requires an explicit action, additional permission, and leaves an audit record."
      },
      "eventStaff": {
        "title": "Event staff",
        "description": "Least privilege by role within the event: check-in staff see only name, organization, job title and the check-in result; the mobile number is viewable only by the event owner for urgent contact and logged; dietary details can be exported only by the owner and manager, each export logged."
      }
    }
  },
  "thirdParty": {
    "heading": "Third-party services",
    "description": "Depending on the deployment environment, some features rely on the following third-party services; whether each is active depends on the environment, and the sign-in page and observed behavior are authoritative:",
    "items": {
      "oidc": "If your account signs in via your school's or organization's single sign-on (OIDC, currently integrated with Google Workspace), that identity provider processes your sign-in and basic profile data (e.g. email, name).",
      "turnstile": "Registration, sign-in, and password-reset requests are checked by Cloudflare Turnstile for bot protection; this sends your IP address and a verification token to Cloudflare.",
      "email": "System notification emails (verification, password reset, judge invitations) are sent via Cloudflare Email Service, only to the email address you provided. This also covers judges' new-assignment notices, assignment-change notices, score-reopened notices and judging reminders (including the automatic pre-deadline reminder when an organizer turns it on); these emails never name submissions or teams and never include the reason an organizer gave when reopening a score."
    }
  },
  "children": {
    "heading": "Minor users",
    "description": "If a participant is a minor, we recommend their school, advisor, or guardian help verify registration details. For questions about how a minor's personal data is handled, please contact us at the address below."
  },
  "related": {
    "heading": "Related pages",
    "dataPolicy": "Data Policy (retention, work ownership, account & data deletion)",
    "terms": "Terms of Use",
    "trust": "Trust Center",
    "contact": "Questions about this notice can be sent to"
  }
}
